import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { cancelCalculationRename, renameCalculation } from '../../modules/calculation';

import { getUIText } from '../../utils/index';

class RenameDialog extends React.Component {

  state = {
    newName: 'Name'
  }

  initName = () => {
    const { project } = this.props;
    const calc = project.calculations[project.calculationIndex] || {};
    this.setState({name: calc.name});
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  }

  onKeyPress = event => {
    if(event.which === 13) {
      const { onCalculationRename} = this.props;
      if(onCalculationRename) {
        onCalculationRename(this.state.name);
      }
    }
  }

  render() {
    const {
      project,
      onCalculationRename,
      onCancelCalculationRename,
      app,
      translations,
      ...other
    } = this.props;

    // onRequestClose laukaistaan kun klikataan dialogin ulkopuolella
    return (
      <Dialog
        onClose={onCancelCalculationRename}
        TransitionProps={{ onEnter: this.initName }}
        {...other}
      >
        <DialogTitle>{getUIText('DIALOG_RENAME-CALCULATION-TITLE', app.language, translations)}</DialogTitle>
        <DialogContent>
          <TextField
            label={getUIText('GENERAL-NAME', app.language, translations)}
            value={ this.state.name || '' }
            onChange={this.handleChange('name')}
            onKeyPress={this.onKeyPress.bind(this)}
            margin="normal"
            autoFocus
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancelCalculationRename} color="primary">
            {getUIText('GENERAL-CANCEL', app.language, translations)}
          </Button>
          <Button onClick={onCalculationRename.bind(this, this.state.name)} color="primary" autoFocus>
            {getUIText('GENERAL-APPLY', app.language, translations)}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

RenameDialog.propTypes = {
    project: PropTypes.object,
    app: PropTypes.object,
    translations: PropTypes.object,
  onCalculationRename: PropTypes.any,
  onCancelCalculationRename: PropTypes.any,
};

const mapStateToProps = (state) => {
    return {
      project: state.project,
      app: state.app,
      translations: state.translations,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
      onCancelCalculationRename: index => dispatch(cancelCalculationRename()),
      onCalculationRename: name => dispatch(renameCalculation({ name: name })),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(RenameDialog);
